import React from 'react';

export default () => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M7.5 13.4766L16.3281 4.64844L17.5 5.82031L7.5 15.8203L2.85156 11.1719L4.02344 10L7.5 13.4766Z" fill="currentColor"/>
</svg>
)
